module.exports = __webpack_public_path__ + "img/heard.a3460dd1.png";